module.exports = __webpack_public_path__ + "media/registration/workshops@3x-50923e74.png";